import { Datasources } from '@adflow/types';
import { SourceConfig } from '..';

type StageMarketConfig = NonNullable<SourceConfig['stageMarkets']>[string];

export function getSelectedStage(
  selectedOptions: Set<Datasources.SourceType>,
  marketTypes: Datasources.SourceType[],
): Datasources.SourceType | undefined {
  return Array.from(selectedOptions).find((opt) => marketTypes.includes(opt));
}

export function getStageMarketConfig(
  selectedStage: Datasources.SourceType | undefined,
  stageMarkets: SourceConfig['stageMarkets'],
): StageMarketConfig | null {
  if (!selectedStage || !stageMarkets) return null;
  return stageMarkets[selectedStage] ?? null;
}

export function shouldShowOddsFormat(
  sourceNeedsOdds: boolean | undefined,
  stageMarketConfig: StageMarketConfig | null,
  selectedMarkets: Datasources.SourceType[],
): boolean {
  return !!(
    sourceNeedsOdds ||
    (stageMarketConfig?.needsOddsFormatting && selectedMarkets.length > 0)
  );
}

export function getInitialSelectedMarkets(
  dataSources: Array<{ type: Datasources.SourceType }>,
  stageMarkets: SourceConfig['stageMarkets'],
): Datasources.SourceType[] {
  const dsTypes = dataSources.map((ds) => ds.type);
  const allStageMarkets = Object.values(stageMarkets ?? {}).flatMap((c) => c.availableMarkets);
  return [...new Set(allStageMarkets.filter((m) => dsTypes.includes(m)))];
}

/**
 * Filters selectedOptions before save so that stage-market values (e.g. FULL_TIME_RESULT)
 * are only included when the user has explicitly selected them in the market multi-select.
 */
export function filterSelectedOptionsForSave(
  selectedOptions: Datasources.SourceType[],
  selectedMarkets: Datasources.SourceType[],
  stageMarkets: SourceConfig['stageMarkets'],
): Datasources.SourceType[] {
  if (!stageMarkets) return selectedOptions;
  const allStageMarketValues = Object.values(stageMarkets).flatMap((c) => c.availableMarkets);
  const selectedMarketSet = new Set(selectedMarkets);
  return selectedOptions.filter(
    (opt) => !allStageMarketValues.includes(opt) || selectedMarketSet.has(opt),
  );
}
